import React from 'react';

const pause = { icon: (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M181.3 0H74.7c-17.6 0-32 14.4-32 32v448c0 17.6 14.4 32 32 32h106.7c17.6 0 32-14.4 32-32V32C213.3 14.4 199 0 181.3 0z"/><path d="M437.3 0H330.7c-17.6 0-32 14.4-32 32v448c0 17.6 14.4 32 32 32h106.7c17.6 0 32-14.4 32-32V32C469.3 14.4 455 0 437.3 0z"/></svg>)};

export default pause;
